module.exports = __webpack_public_path__ + "static/media/clover.4204a79c.svg";